import { cn } from '@/lib/utils';
import { Badge } from '@/components/ui/badge';
import { IconLoader2 } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';

export interface StatusCardProps {
  title: string;
  message: string;
  loading?: boolean;
  error?: string | null;
  href: string;
  statusChip: {
    label: string;
    variant?: 'default' | 'secondary' | 'destructive' | 'outline';
    className?: string;
  };
  className?: string;
}

export default function StatusCard({
  title,
  message,
  loading = false,
  error = null,
  href,
  statusChip,
  className,
}: StatusCardProps) {
  const navigate = useNavigate();

  const handleClick = () => {
    if (href.startsWith('/') && !href.startsWith('//')) {
      navigate(href);
    }
  };

  return (
    <div
      onClick={handleClick}
      className={cn(
        'rounded-lg border border-border/60 bg-card p-4 sm:p-5 cursor-pointer',
        'transition-colors hover:bg-accent/50',
        'h-full',
        className,
      )}
    >
      <p className="text-sm font-medium">{title}</p>
      <div className="mt-3 flex flex-col gap-1.5">
        <div className="flex items-center gap-2">
          <Badge
            variant={statusChip.variant || 'default'}
            className={statusChip.className}
          >
            {statusChip.label}
          </Badge>
          {loading && (
            <IconLoader2 className="h-3.5 w-3.5 animate-spin text-muted-foreground" />
          )}
        </div>
        <p className="text-xs text-muted-foreground">{error || message}</p>
      </div>
    </div>
  );
}
